import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const SoftWashPage2 = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Drone Soft Wash & Pressure Wash - Flyby Shine</title>
                        <meta name="description" content="Elevate Your Home and Property's Appeal with Our Advanced Drone-Assisted Pressure and Soft Washing Services." />
                        <meta name="keywords" content="Drone Cleaning, Drone Soft Wash, Pressure Wash, Drone-Assisted Pressure, Soft Washing Services, Drone cleaning technology, controlled pressure application, tailored to different surfaces, minimizing the risk of damage, valuable property, flexibility to adapt to various surfaces, architectural styles, high-rise office buildings, complex industrial sites, delicate historical structures, optimal results, faster and more efficient, disrupting your daily operations" />
                        <meta property="og:image" content="/assets/droneHouse.jpg" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Residential & Home'}
                    title={'Drone Soft Wash & Pressure Wash'}
                    description={`Elevate Your Home and Property's Appeal with Our Advanced Drone-Assisted Pressure and Soft Washing Services.`}
                    banner={{
                        video: '/assets/videos/residential.mp4',
                        alt: 'A drone cleaning a commercial building',
                        thumbnail: '/assets/videos/thumbnails/residential.png'
                    }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/residential-home'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Wash away the dirt and grime from your property with our advanced drone-assisted pressure and soft washing services."}
                    subTitle={"Drone Soft Wash & Pressure Wash"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/homeAfter.jpg',
                        },
                        secondImage: {
                            imageUrl: '/assets/homeBefore.jpg',
                        }

                    }
                    ]}

                />

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/droneHouse.jpg', alt: 'nationwide about us image' }}
                        title={'Minimized Risk of Property Damage'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'Our drone cleaning technology allows for controlled pressure application tailored to different surfaces, minimizing the risk of damage to your valuable property.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. We customize our approach to fit your specific requirements, ensuring optimal results for every job.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/home.mp4',
                            thumbnail: '/assets/videos/thumbnails/home.png'

                        }}
                        title={'Prevent Home Damage'}
                        heading={{ image: '/assets/star.svg', alt: 'faster bolt icon' }}
                        description={'Over time, dirt, mold, and mildew can cause significant damage to your home’s exterior, leading to costly repairs. Our drone cleaning services help protect your investment by removing harmful substances before they cause any harm'}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default SoftWashPage2
